import React, { useEffect, useState } from 'react';
import {Tabs} from 'antd';
import PubSub from "pubsub-js";
import {createFromIconfontCN} from '@ant-design/icons';
import { MenuModuleType, MenuRecord, readMenuModule, readMenus, updateMenuModule, writeMenuModule, writeMenus } from '../../../../utils/storage';

import { publishSliderNav, subscribeHeaderMenu } from '../../../../utils/ps';
import { isTenantJS } from '../../../../utils/tenant-assoc';
import { GetMenuService } from '../../../../services/plat/MenuService';

import './index.less'

const IconFont = createFromIconfontCN({
    scriptUrl: [
        '//at.alicdn.com/t/c/font_2343612_2ojyi94p9ix.js',
    ],
});

const HeaderMenu = ()=> {

  const [activeKey, setActiveKey] = useState('')

  const [menus, setMenus] = useState<MenuRecord[]>([])

  const handleChange = (key: string, isInit = false, list: MenuRecord[] | null = null) => {

    const items = (list ?? menus)
    const index = items.findIndex((t)=> t.key === key)

    const item = items[index]

    setActiveKey(key)

    updateMenuModule({
      levelOneTitle: item.title,
      levelOneKey: item.key,
      levelOneIndex: index
    },  false)

    // 派发事件 !添加延迟的原因是侧栏可能没有执行 subscribeSliderNav
    setTimeout(()=> {
      publishSliderNav({
        isInit,
        menus: item.children
      });
    }, 100)
  }

  // 缓存一级菜单标题和key
  const handleOneLevelCache = ([{title, key}]: MenuRecord[], nil: boolean) => {
    if(!nil){
      updateMenuModule({
        levelOneTitle: title,
        levelOneKey: key,
        levelOneIndex: 0
      })
      return
    }

    writeMenuModule({
      levelOneTitle: title,
      levelOneKey: key,
      levelOneIndex: 0,
    })
  }

  // 非君实租户清除随访任务列表
  const removeVisitEntry = (list: MenuRecord[])=> {
    if(isTenantJS()) {
      return
    }

    let skip = false;
    const removeEntry = (target: MenuRecord[])=> {
      if(!Array.isArray(target)) {
        return
      }
      for(const i in target) {
        if(skip) {
          return
        }
        const item = target[i]
        if(item.key === 'DCT_PAGE_VISIT_LIST') {
          target.splice(Number(i), 1)
          skip = true;
          return
        }
        const next = item.children
        if(Array.isArray(next) && next.length > 0) {
          removeEntry(next)
        }
      }
    }
    removeEntry(list)
  }

  const fetchData = async ()=> {
    const menuModule = readMenuModule()
    
    let index  = 0;
    let isRefresh  = true;

    if(menuModule) {
      index = (menuModule as MenuModuleType).levelOneIndex
    }else {
      isRefresh  = false;
    }

    let localMenus = readMenus();

    if (localMenus.length === 0) {
      localMenus = await GetMenuService()
      removeVisitEntry(localMenus)
      writeMenus(localMenus);
    } else {
      handleOneLevelCache(localMenus, menuModule === null);
    }

    setMenus(localMenus)
    setActiveKey(localMenus[index].key)
    handleChange(localMenus[index].key, isRefresh, localMenus);
  }

  useEffect(()=> {
    subscribeHeaderMenu(()=> fetchData)

    fetchData()
  }, [])

  return (
    <div className='header-menu-wrapper'>
      <Tabs
        activeKey={activeKey} 
        onChange={(value)=> handleChange(value)}
        items={menus.map(({ key, iconName, title })=> ({
          key,
          label: iconName ? (<><IconFont type={iconName}/>{title}</>) : title
        }))}
      />
    </div>
  )
}

export default HeaderMenu